<!-- CrossListingGate.vue -->
<script setup>
import { computed } from 'vue'
import { useStore } from 'vuex'
const store = useStore()

const enabled = computed(() => store.state.eshop.eshop?.config?.CROSSLISTING)
</script>

<template>
  <slot v-if="enabled" />
</template>
